































import { Component, Vue } from 'vue-property-decorator';
import InfoLink from '@/components/InfoLink.vue';
@Component({
  components: {
    InfoLink,
  },
})
export default class Footer extends Vue {
  public year = new Date().getFullYear();
}
